import React from "react"

const Caption = ({ reference, title, body, source }) => (
  <div className="caption">
    {reference && <span className="caption__reference">{reference}.</span>}
    {title && (
      <em dangerouslySetInnerHTML={{ __html: title }} />
    )}
    {body && (
      <span
        className="caption__body"
        dangerouslySetInnerHTML={{ __html: body }}
      />
    )}
    {source && (
      <div
        className="caption__source"
        dangerouslySetInnerHTML={{ __html: source }}
      />
    )}
  </div>
)

export default Caption
